import { AnySchema, Context } from "joi";

export const getObjectByPathWithMessage = (
  currentObject: { [key: string]: any } | string,
  path: (string | number)[],
  message: string,
): { [key: string]: any } | string => {
  if (path.length > 0) {
    if (typeof currentObject === 'undefined') {
      currentObject = {};
    }

    // @ts-ignore
    currentObject[path[0]] = getObjectByPathWithMessage(
      // @ts-ignore
      currentObject[path[0]],
      path.slice(1),
      message,
    );
    return currentObject;
  } else {
    currentObject = message;
    return currentObject;
  }
};
export const getErrors = (schema: AnySchema, values: { [key: string]: any }, context?: Context) => {
  let errors = {};
  const result = schema.validate(values, { abortEarly: false, context });

  if (!!result.error) {
    let resolvedPath = {};
    result.error.details.forEach(error => {
      resolvedPath = {
        ...resolvedPath,
        // @ts-ignore
        ...getObjectByPathWithMessage(resolvedPath, error.path, error.message),
      };

      // @ts-ignore
      errors = { ...errors, ...resolvedPath };
    });
  }

  return errors;
};
